import type { Participant } from '@seen/core/models/patients/participant'
import { TypographyDetail } from '@seen/ui'
import { compact } from 'lodash-es'
import type { ComponentPropsWithoutRef, JSX, ReactNode } from 'react'
import { ResourceCard } from '#src/components/core/ResourceCard.tsx'
import { PatientName } from '#src/components/patient/PatientName.tsx'

interface PatientCardProps extends ComponentPropsWithoutRef<'figure'> {
  participant: Participant
  className?: string
  avatar?: ReactNode
  actions?: ReactNode
}

export function PatientCard({
  participant,
  className,
  avatar,
  actions,
  ...delegated
}: PatientCardProps): JSX.Element {
  const subtext = compact([
    participant.genderInitial,
    participant.age,
    participant.birthDateFormatted,
    participant.seenMRN && `MRN ${participant.seenMRN}`,
  ]).join(', ')

  return (
    <ResourceCard
      value={participant.toFhirResource()}
      display={<PatientName participant={participant} />}
      detail={
        <TypographyDetail className="text-foreground-secondary">
          {subtext}
        </TypographyDetail>
      }
      className={className}
      avatar={avatar}
      actions={actions}
      {...delegated}
    />
  )
}
